import { METHODS, API_BASE_URL, apiCall } from './config'

export const AgentApi = {
	updateAgent: (id, payload) =>
		apiCall(METHODS.POST, API_BASE_URL, `/v1/agents/${id}`, payload),
}
